import { render, staticRenderFns } from "./buynow.vue?vue&type=template&id=cb3dc782&scoped=true&"
import script from "./buynow.vue?vue&type=script&lang=js&"
export * from "./buynow.vue?vue&type=script&lang=js&"
import style0 from "./buynow.vue?vue&type=style&index=0&id=cb3dc782&scoped=true&lang=less&"
import style1 from "./buynow.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3dc782",
  null
  
)

export default component.exports